import { Ajax } from '@/common'

// The gateway follows the existing /commbook/title -> /public/title mapping.
const base = '/commbook/global'

function unwrap(response) {
  if (!response || response.code !== '0000' || response.data == null) {
    throw Object.assign(
      new Error((response && response.message) || 'Unable to load Commbook. Please try again.'),
      { code: response && response.code }
    )
  }
  return response.data
}

export async function getLocations() {
  const data = unwrap(await Ajax.get(`${base}/locations`, {}))
  if (!Array.isArray(data)) throw new Error('Unable to load locations. Please try again.')
  return data
}

export async function getNavigation() {
  const data = unwrap(await Ajax.get(`${base}/navigation`, {}))
  if (!Array.isArray(data.locations)) throw new Error('Unable to load locations. Please try again.')
  return data
}

export async function markConversationRead(id, readSnapshot) {
  return unwrap(
    await Ajax.post(`${base}/conversations/${encodeURIComponent(id)}/read`, { readSnapshot })
  )
}

export async function markAllConversationsRead(filter) {
  return unwrap(await Ajax.post(`${base}/read-all`, filter))
}

export async function setConversationStar(id, starred) {
  return unwrap(
    await Ajax.post(`${base}/conversations/${encodeURIComponent(id)}/star`, { starred })
  )
}

export async function getConversations(params) {
  const data = unwrap(await Ajax.post(`${base}/conversations`, params))
  if (!Array.isArray(data.records))
    throw new Error('Unable to load conversations. Please try again.')
  return data
}

export async function getConversation(id) {
  const data = unwrap(await Ajax.get(`${base}/conversations/${encodeURIComponent(id)}`, {}))
  if (!data.id) throw new Error('This conversation is unavailable.')
  return data
}

export async function sendReply(id, response, attachments) {
  return unwrap(
    await Ajax.post(`${base}/conversations/${encodeURIComponent(id)}/replies`, {
      response,
      attachments
    })
  )
}

export async function editConversation(id, request) {
  return unwrap(await Ajax.post(`${base}/conversations/${encodeURIComponent(id)}/edit`, request))
}

export async function deleteConversation(id) {
  return unwrap(await Ajax.post(`${base}/conversations/${encodeURIComponent(id)}/delete`, {}))
}

export async function editReply(conversationId, replyId, response, attachments) {
  return unwrap(
    await Ajax.post(
      `${base}/conversations/${encodeURIComponent(conversationId)}/replies/${encodeURIComponent(replyId)}/edit`,
      { response, attachments }
    )
  )
}

export async function deleteReply(conversationId, replyId) {
  return unwrap(
    await Ajax.post(
      `${base}/conversations/${encodeURIComponent(conversationId)}/replies/${encodeURIComponent(replyId)}/delete`,
      {}
    )
  )
}

export async function getCreateTopics() {
  const data = unwrap(await Ajax.get(`${base}/create/topics`, {}))
  if (!Array.isArray(data)) throw new Error('Unable to load topics. Please try again.')
  return data
}

export async function searchCreateStudents(query) {
  const data = unwrap(await Ajax.get(`${base}/create/students`, { q: query }))
  if (!Array.isArray(data)) throw new Error('Unable to search students. Please try again.')
  return data
}

export async function createConversations(request) {
  const data = unwrap(await Ajax.post(`${base}/create`, request))
  if (!Array.isArray(data) || !data.length)
    throw new Error('Unable to create the conversation. Please try again.')
  return data
}
